<script>
export default {
  emits: ["valueChanged"],
  props: [
    "classes",
    "labelText",
    "errorMessage",
    "modelValue",
    "required",
    "type"
  ],
  components: {},
  data() {
    return {
      focused: false,
      value: "",
      randomId: null
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        val ? (this.value = val) : "";
      }
    }
  },
  methods: {
    emitValue(event) {
      this.$emit("valueChanged", event);
    },
    getRandomId() {
      return (Math.random() + 1).toString(36).substring(7);
    }
  },
  beforeMount() {
    this.randomId = this.getRandomId();
  }
};
</script>

<template>
  <div class="requestcall__form-input-wrapper">
    <input
      @focus="focused = true"
      @blur="focused = false"
      autocomplete="off"
      v-model="value"
      @input="emitValue($event)"
      id="name"
      :type="type ? type : null"
    />
    <label
      for="name"
      class="wc"
      :class="[
        { focused: focused || value.length },
        { 'is-required': required }
      ]"
      >{{ labelText }}</label
    >
    <p class="errormessage">{{ errorMessage }}</p>
  </div>
</template>

<style lang="scss" scoped>
.requestcall__form-input-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  .errormessage {
    color: red;
    padding-top: 8px;
    font-size: 14px;
  }
  input {
    width: 100%;
    padding-top: 29px;
    height: 64px;
    background-color: var(--primary);
    // background-color: #f9fafa;
    border: 1px solid var(--primary);
    color: var(--secondary);
    padding-left: 16px;
    font-size: 14px;
    line-height: 24px;
    border-radius: 4px;
    transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
  }
  label {
    color: var(--secondary);
    font-size: 14px;
    line-height: 24px;
    position: absolute;
    top: 0;
    left: 16px;
    transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
    transform: translateY(20px);
    z-index: 3;
    &.is-required::after {
      content: "*";
      color: red;
      font-size: 14px;
      line-height: 24px;
    }
    &.focused {
      transform: translate(-9%, 10px) scale(0.84);
    }
    // @include mq(mobile) {
    //   transform: translateY(15px);
    //   &.focused {
    //     transform: translate(-9%, 7px) scale(0.84);
    //   }
    // }
  }
}
</style>
